import { type IconNames, CustomList, Heading } from '@cinch-labs/design-system'
import { useViewport } from '@cinch-labs/shared-util'
import {
  StoryBlokRichText,
  StoryblokImage,
  getStoryblokImageServiceUrl,
} from '@cinch-nx/data-storyblok'
import styles from './why-cinch.module.css'
import Image from 'next/legacy/image'
import WhyCinchCardComponent from './why-cinch-card-component'

interface WhyCinchCard {
  name: string
  icon: string
  title: string
  body: StoryBlokRichText
}

export interface WhyCinchProps {
  title: string
  image: StoryblokImage
  cards: WhyCinchCard[]
}

const WhyCinch: React.FC<WhyCinchProps> = ({ image, title, cards }) => {
  const { vw } = useViewport({
    updateOnResize: true,
    updateOnOrientationChange: true,
  })
  const isMobile = vw < 1024

  return (
    <section className={styles['whyCinchContainer']} data-testid="whycinch">
      <div className={styles['whyCinchInner']}>
        <Heading fontSize="h1" className={styles['whyCinchHeading']}>
          {title}{' '}
        </Heading>

        <div className={styles['contentWrapper']}>
          <CustomList
            customClassNames={{
              bulletContainer: styles['bulletContainer'],
              listItem: styles['listItem'],
            }}
          >
            {cards.map((card, idx) => (
              <WhyCinchCardComponent
                key={card.name ?? idx}
                title={card.title}
                name={card.name}
                icon={card.icon as IconNames}
                body={card.body}
              />
            ))}
          </CustomList>
          {!isMobile ? (
            <div
              className={styles['whyCinchImageContainer']}
              data-testid="featured-cards-image-section"
            >
              {!image.filename.includes('storyblok') ? (
                <Image
                  src={image.filename}
                  alt={image.alt ?? ''}
                  layout="responsive"
                  width={360}
                  height={414}
                />
              ) : (
                <img
                  src={getStoryblokImageServiceUrl(image.filename, {
                    width: 360,
                    height: 414,
                    filters: [{ quality: 80 }],
                  })}
                  alt={image.alt ?? ''}
                />
              )}
            </div>
          ) : null}
        </div>
      </div>
    </section>
  )
}

export default WhyCinch
